import { cn } from "@/lib/utils";
import { BRAND } from "@/lib/brand";

export function BrandMark({ className, textClass = "text-lg", iconClass = "h-12 w-12", showText = true }) {
  return (
    <div className={cn("flex items-center gap-3", className)} data-testid="brand-mark">
      <img
        src={BRAND.square}
        alt="1APPONLY"
        className={cn("rounded-xl object-cover shrink-0 shadow-sm ring-1 ring-black/5", iconClass)}
      />
      {showText && (
        <span className={cn("font-display font-black leading-none tracking-tight", textClass)}>
          <span className="text-amber-500">1</span>
          <span className="text-primary">APP</span>
          <span className="text-amber-500">ONLY</span>
        </span>
      )}
    </div>
  );
}
